import script from "./CoachingButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachingButton.vue?vue&type=script&setup=true&lang=js"

import "./CoachingButton.vue?vue&type=style&index=0&id=2fc6d793&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc6d793"]])

export default __exports__